import { useTranslation } from "react-i18next";
import ProfessionalImage from "../assets/professional.jpg";
import PartnerOne from "../assets/partnerone.png";
import PartnerTwo from "../assets/partnertwo.png";
import PartnerThree from "../assets/partnerthree.png";
import PartnerFour from "../assets/partnerfour.png";
import PartnerFive from "../assets/partnerfive.png";
const PartnerBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full mx-auto bg-black/5">
      {/* Hero Section */}
      <div className="relative w-full w-[85%] mx-auto min-h-[600px] md:min-h-[650px] lg:min-h-[700px] flex flex-col md:flex-row items-center">
        {/* Left Content */}
        <div className="relative z-10 px-4 sm:px-6 lg:px-8  md:w-1/2">
          <div className="max-w-xl">
            {/* Heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4">
              {t("Become a")} <br />
              {t("yslearn Partner")}
            </h1>

            {/* Subheading */}
            <p className="text-base md:text-lg text-gray-700 mb-8 leading-relaxed">
              {t(
                "We partner with innovators, distributors, & online resellers around the world to help individuals and businesses embrace digital transformation through skills training."
              )}
            </p>

            {/* CTA Button */}
            <button className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-8 rounded-md transition duration-300 text-base md:text-lg">
              {t("Contact Us")}
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative md:w-1/2 flex justify-center items-center">
          <img
            src={ProfessionalImage}
            alt={t("Professional Collaboration")}
            className="w-full max-w-md md:max-w-lg lg:max-w-xl rounded-lg shadow-xl"
          />
        </div>
      </div>

      {/* Partners Section */}
      <div className="   px-4 sm:px-6 lg:px-8 -mt-16 md:-mt-20 lg:-mt-24 relative z-20">
        <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg">
          {/* Partners Heading */}
          <h2 className="text-center text-gray-700 text-lg md:text-xl p-4">
            {t(
              "Partnering with the world's leading companies, universities & certification bodies"
            )}
          </h2>

          {/* Partners Logo Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-6 md:gap-8 items-center justify-items-center">
            {/* Example Logos */}
            <div className="  flex items-center">
              <img
                src={PartnerOne}
                alt={t("Duke Continuing Studies")}
                className="max-h-full object-contain"
              />
            </div>
            <div className=" flex items-center">
              <img
                src={PartnerTwo}
                alt={t("Eviare")}
                className="max-h-full object-contain"
              />
            </div>
            <div className="   flex items-center">
              <img
                src={PartnerThree}
                alt={t("PTI")}
                className="max-h-full object-contain"
              />
            </div>
            <div className=" flex items-center">
              <img
                src={PartnerFour}
                alt={t("ILX")}
                className="max-h-full object-contain"
              />
            </div>
            <div className="  flex items-center">
              <img
                src={PartnerFive}
                alt={t("KGC")}
                className="max-h-full object-contain"
              />
            </div>
            <div className="  flex items-center">
              <img
                src={PartnerOne}
                alt={t("Transformative")}
                className="max-h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerBanner;
